import { parseBooleanValue } from "../../util";
import { IDocumentTypeIndexCategory } from "../model/DocumentTypeIndexCategory";

const DocumentTypeIndexCategoryParamMapper = (
  item: IDocumentTypeIndexCategory
) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid),
    required: parseBooleanValue(item.required)
  };
};

export default DocumentTypeIndexCategoryParamMapper;
